/* OJ Subscription choice - the two things CSS cannot do from outside the
   Recharge widget's shadow root. See oj-subscription.css.

   1. Mark the widget with data-oj-sub-selected while the subscription is
      the chosen option, so the note under its name can hide while the
      benefit list shows.
   2. Give the plan dropdown's options dark text on white. The dropdown
      takes white text inside the black box, and on Windows the open list
      would otherwise be white on white. */
(function () {
  var PLANS_CSS = 'option{color:#121212;background:#fff}';

  function addStyle(root, id, css) {
    if (!root || root.querySelector('style[data-oj="' + id + '"]')) return;
    var s = document.createElement('style');
    s.setAttribute('data-oj', id);
    s.textContent = css;
    root.appendChild(s);
  }

  function sync(widget) {
    var root = widget.shadowRoot;
    if (!root) return false;
    var sub = root.querySelector('[part~="rc-purchase-option__subscription"]');
    var chosen = !!sub && (sub.getAttribute('part') || '').split(/\s+/).indexOf('rc-purchase-option__selected') > -1;
    widget.toggleAttribute('data-oj-sub-selected', chosen);
    root.querySelectorAll('rc-selling-plans').forEach(function (el) {
      addStyle(el.shadowRoot, 'plans', PLANS_CSS);
    });
    return true;
  }

  function watch(widget) {
    if (widget.__ojSub || !sync(widget)) return;
    widget.__ojSub = true;
    new MutationObserver(function () { sync(widget); }).observe(widget.shadowRoot, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['part', 'rc-selected']
    });
  }

  function scan() {
    document.querySelectorAll('recharge-subscription-widget').forEach(watch);
  }

  // Recharge draws the widget after its own script loads, so look for a while.
  var tries = 0;
  var timer = setInterval(function () {
    scan();
    if (++tries > 60) clearInterval(timer);
  }, 250);
  document.addEventListener('DOMContentLoaded', scan);
})();
